import { defineComponent as _defineComponent } from 'vue'
import {onMounted, ref, computed, onBeforeMount, nextTick} from 'vue';
import {getPermissionData, getWechatAppUrl} from '@/api/miscellaneous';
import userStoreModule from '@/store/modules/user';
import appStoreModule from '@/store/modules/app';
import {useRouter, useRoute} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'RestrictDialog',
  props: {
    modelValue: {
        type: Boolean,
        default: false,
    },
    code: [String, Number],
    type: [String],
},
  emits: ['update:modelValue'],
  setup(__props, { expose, emit: emits }) {
  expose();

const props = __props

const router = useRouter();
const route = useRoute();

const vipMap = {
    1: '普通会员',
    3: '白银会员',
    5: '未知会员',
    6: '黄金会员',
    7: '皇冠会员',
};


const vpiLevel = ref('');
const permissionData = ref();
const vipRank = ref(5);
onBeforeMount(() => {
    getPermissionData().then(res => {
        //@ts-ignore
        vpiLevel.value = vipMap[userStoreModule.userInfo.vipRank];
        vipRank.value = userStoreModule.userInfo.vipRank || 5;
        permissionData.value = res;
    });
});



const close = () => {
    emits('update:modelValue', false);
};

const jumpApplet = () => {
    // getWechatAppUrl({
    //     url: 'packageA/pages/before_vip/index',
    //     query: 'tab=0&level=6',
    // }).then(res => {
    //     // alert('test');
    //     location.href = JSON.parse(res).openlink;

    // });

    router.push({
        name: 'OpenMembership',
        query: {
            type: 6,
            vipform: `${route.meta.title || '未知页面'},号码查看超限制`,
        },
    });
};

const show = computed(() => {
    return Object.keys(permissionData.value).length;
});


const __returned__ = { router, route, vipMap, props, vpiLevel, permissionData, vipRank, emits, close, jumpApplet, show, onMounted, ref, computed, onBeforeMount, nextTick, getPermissionData, getWechatAppUrl, userStoreModule, appStoreModule, useRouter, useRoute }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})